import * as common from 'helpers/util-common';
import _ from "lodash";
import { minDateForInputDateFields } from 'models/common.models';
import React, { Component } from 'react';
import { Field, reduxForm, touch } from 'redux-form';
import { Confirm, Form, Grid, Icon, GridColumn, GridRow} from 'semantic-ui-react';
import DateTimeForm from 'shared-components/DatePicker';
import RenderInput from 'shared-components/Input';
import DropdownMultipleSelection from 'shared-components/MultiSelectDropDown';
import RenderRadioField from 'shared-components/RadioBox';
import RenderSelect from 'shared-components/Select';
import TextArea from 'shared-components/TextArea';
import { MembershipTypes } from '../../members.model';
import * as _func from './function';
import CustomAlertModal from 'shared-components/CustomAlertModal';
import CustomConfirmModal from 'shared-components/CustomAlertModal/CustomConfirmModal';
import ReduxCheckboxElement from 'shared-components/CheckBox/redux-checkbox';

class MemberCommitteeBasicDetailsEdit extends Component {
    prevState = {}

    constructor(props) {
        super(props);
        this.state = {
            maxDate: common.formatDateToMMDDYYYY(),
            currentDate: common.formatDateToMMDDYYYY(),
            minInactiveDate: '01/01/1900',
            memActiveDate: '01/01/1990',
            minCalDate: '01/02/1900',
            minDate: _(this.props.initialValues).get('EstablishmentDate') ? common.formatDateToMMDDYYYY(this.props.initialValues.EstablishmentDate) : common.formatDateToMMDDYYYY(minDateForInputDateFields),
            committeeJoinDate: this.props.memberCommitteeDetails.CommitteeJoinDate,
            inactiveCommitteeDate: this.props.memberCommitteeDetails.TopSection.MemberCommitteeStatus.toLowerCase() === 'inactive' ? this.props.memberCommitteeDetails?.InactiveDate : common.formatDateToMMDDYYYY(),
            officerAppointedDate: this.props.memberCommitteeDetails.OfficerAppointedDate === '' ? common.formatDateToMMDDYYYY() : this.props.memberCommitteeDetails.OfficerAppointedDate,
            memberCommitteeStatus: this.props.memberCommitteeDetails.TopSection.MemberCommitteeStatus.toLowerCase(),
            inactiveReasonSelectedValue: (this.props.memberCommitteeDetails.TopSection && this.props.memberCommitteeDetails.TopSection.InactiveReasonId) ? this.props.memberCommitteeDetails.TopSection.InactiveReasonId : 'select',
            inactiveReason: [],
            officerTitleSelectedValue: this.props.memberCommitteeDetails.TopSection.OfficerTitleId > 0 ? this.props.memberCommitteeDetails.TopSection.OfficerTitleId : '',
            officerTitle: [],
            isCommitteeJoinDateGreaterThanClassificationDate: false,
            isCommitteeJoinDateGreaterThanVoteDate: false,
            isCommitteeJoinDateGreaterThanBothDates: false,
            honoraryStatus: this.props.memberCommitteeDetails.TopSection.HonoraryStatus === true ? 'yes' : 'no',
            committeePayStatus: this.props.memberCommitteeDetails.TopSection.CommitteePayStatus === true ? 'yes' : 'no',
            feeGroupId: this.props.memberCommitteeDetails.TopSection.FeeGroupId || 0,
            feeGroupList: [],
            isShowAdministrativeAssistantPopup: false,
            isShowAdministrativeAssistantOrStaffManagerPopup: false,
            officerTitleName: '',
            disableFieldForStudent: false,
            latestJoinDate:'',
            isMemberCommitteeStatusActive: !(this.props.memberCommitteeDetails.TopSection && this.props.memberCommitteeDetails.TopSection.MemberCommitteeStatus.toLowerCase() === 'inactive'),
            activeCommitteeId: this.props.activeCommitteeId,
            previousOfficerTitle: '',
            previousOfficerJoinedDate: '',
            previousOfficerEndDate: '',
            isArchieveOfficerDetail: false,
            isShowPreviousOfficer: false,
            isShowArchievePopup: false
        }
    }

    componentWillMount() {
        _func.setClassInstance(this);
    }
    componentDidMount() {
        this.props.change('FeeGroupId', (this.props.memberCommitteeDetails.TopSection.FeeGroupId || 0).toString());
        this.prevState = this.state;
        
    }
    componentWillReceiveProps(nextProps) {
        this.setState({
            officerTitle: nextProps.memberCommitteeOfficerTitles ? nextProps.memberCommitteeOfficerTitles : nextProps.officerTitleList,
            inactiveReason: nextProps.inactiveReasonList
        })
        if (this.state.officerTitle && this.state.officerTitle.length > 0) {
            let result = this.state.officerTitle.filter((filterResult) => {
                return filterResult.value === this.state.officerTitleSelectedValue;
            });
            if (result && result.length > 0) {
                this.setState({ officerTitleName: _.get(result[0], 'text') })
            }

        }
    }

    handleChangeOfficerTitle = (event, value) => {
        this.setState({ officerTitleSelectedValue: value })
        const { officerTitle } = this.state;
        let oldOfficer = this.props.memberCommitteeDetails?.TopSection?.OfficerTitleName;
        let oldOfficerAppointedDate = oldOfficer ? common.formatDateToMMDDYYYY(this.props.memberCommitteeDetails?.TopSection?.OfficerAppointedDate) : common.formatDateToMMDDYYYY();
        if (officerTitle && officerTitle.length > 0) {
            let result = officerTitle.filter((filterResult) => {
                return filterResult.value === value;
            });
            if (result && result.length > 0) {
                this.setState({ officerTitleName: _.get(result[0], 'text') });
                if (oldOfficer && oldOfficer != _.get(result[0], 'text')) {
                    this.setState({
                        isShowPreviousOfficer: true,
                        officerAppointedDate: common.formatDateToMMDDYYYY(),
                        previousOfficerJoinedDate: oldOfficerAppointedDate,
                        previousOfficerEndDate: common.formatDateToMMDDYYYY(),
                        previousOfficerTitle: oldOfficer
                    });
                    this.props.change('OfficerAppointedDate', common.formatDateToMMDDYYYY());
                    this.props.change('PreviousOfficerAppointedDate', oldOfficerAppointedDate);
                    this.props.change('PreviousOfficerEndDate', common.formatDateToMMDDYYYY());
                    _func.updatePreviousOffice(true);
                }
                else {
                    this.setState({
                        isShowPreviousOfficer: false,
                        previousOfficerTitle: '',
                        officerAppointedDate: oldOfficerAppointedDate,
                        previousOfficerJoinedDate: '',
                        previousOfficerEndDate: ''
                    });
                    this.props.change('OfficerAppointedDate', oldOfficerAppointedDate);
                    this.props.change('PreviousOfficerAppointedDate', '');
                    this.props.change('PreviousOfficerEndDate', '');
                    _func.updatePreviousOffice(false);
                }
            }

        }
    }

    render() {
        const { messageCodes, handleSubmit, onEditCancel, submitting, memberCommitteeDetails: { TopSection }, initialValues } = this.props
        const { maxDate, currentDate, committeeJoinDate, officerAppointedDate, memberCommitteeStatus, inactiveReasonSelectedValue, inactiveReason, officerTitleSelectedValue, officerTitle, minDate, isCommitteeJoinDateGreaterThanClassificationDate, isCommitteeJoinDateGreaterThanVoteDate, isCommitteeJoinDateGreaterThanBothDates,
            honoraryStatus, committeePayStatus, feeGroupList, isShowAdministrativeAssistantPopup, isShowAdministrativeAssistantOrStaffManagerPopup, officerTitleName, committeeName, disableFieldForStudent, minInactiveDate, inactiveCommitteeDate, isMemberCommitteeStatusActive,
            isArchieveOfficerDetail, isShowArchievePopup, previousOfficerTitle, isShowPreviousOfficer, previousOfficerJoinedDate, previousOfficerEndDate, minCalDate } = this.state;
        return (
            <section className="subCommInfo">
                <Form onSubmit={handleSubmit} noValidate data-testid="memberCommitteeBasicDetailsEdit">
                    <h5>{TopSection.CommitteeSubcommitteeName}
                        <ul className="editDetailsBtn floatRight">
                            <li>
                                <button title="Update" className="updateBtn" type="submit" disabled={submitting}>
                                    <Icon name="check" />
                                </button>
                            </li>
                            <li>
                                <button title="Cancel" className="closeBtn" onClick={onEditCancel}>
                                    <Icon name="close" />
                                </button>
                            </li>
                        </ul>
                    </h5>

                    <Grid divided='vertically' columns={2}>
                        <Grid.Row>
                            <Grid.Column>
                                <Field name="CommitteeJoinDate"
                                    dataTestId="committeeJoinDate"
                                    component={DateTimeForm} label="Committee Join Date"
                                    value={committeeJoinDate}
                                    showTime={false}
                                    required={true}
                                    initialDate={maxDate}
                                    maxDate={maxDate}
                                    minDate={minDate}
                                    normalize={common.dateMasking}
                                    onChange={_func.handleChangeCommitteeJoinDate}
                                    readOnly={false}
                                    disabled={memberCommitteeStatus === 'inactive'}
                                />
                            </Grid.Column>
                        </Grid.Row>

                        <GridRow>
                            <GridColumn width={3}>
                                <Field name="Status" label="Member Committee Status"
                                    component={RenderRadioField}
                                    className="mr10"
                                    type="radio"
                                    selectedValue={memberCommitteeStatus}
                                    onChange={_func.handleChangeMemberCommitteeStatus}
                                    required={true}
                                    options={[{ label: 'Active', value: 'active' }, { label: 'Inactive', value: 'inactive' }]}
                                    isDisabled={!isMemberCommitteeStatusActive}
                                />
                            </GridColumn>
                            {memberCommitteeStatus === 'inactive' && (
                                <GridColumn width={5}>
                                    <Field 
                                        name="InactiveDate"
                                        dataTestId="InactiveDate"
                                        component={DateTimeForm} 
                                        label="Inactive Date"
                                        value={inactiveCommitteeDate}
                                        showTime={false}
                                        required={true}
                                        initialDate={inactiveCommitteeDate}
                                        minDate={minDateForInputDateFields}
                                        maxDate={maxDate}
                                        normalize={common.dateMasking}
                                        readOnly={false}
                                        onChange={_func.handleChangeCommitteeInactiveDate}
                                    />
                                </GridColumn>
                            )}
                            <GridColumn>
                                {memberCommitteeStatus === 'inactive' ?
                                    <Field name="InactiveReason"
                                        component={RenderSelect} label="Inactive Reason"
                                        value={inactiveReasonSelectedValue}
                                        options={inactiveReason}
                                        onChange={_func.handleChangeInactiveReason}
                                        required={true}
                                        disabled={!isMemberCommitteeStatusActive}
                                    /> : ''}
                            </GridColumn>
                        </GridRow>
                        <Grid.Row>
                            <Grid.Column>
                                <Field
                                    name="OfficerTitle"
                                    label="Officer Title"
                                    value={officerTitleSelectedValue}
                                    onChange={(e, value) => this.handleChangeOfficerTitle(e, value)}
                                    disabled={memberCommitteeStatus === 'inactive' || disableFieldForStudent}
                                    component={DropdownMultipleSelection}
                                    isSearch={true}
                                    placeholder="Search by Officer Title"
                                    isMultiple={false}
                                    options={officerTitle}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                {(officerTitleSelectedValue !== 'select' && officerTitleSelectedValue > 0) ?
                                    <Field name="OfficerAppointedDate"
                                        dataTestId="OfficerAppointedDate"
                                        component={DateTimeForm} label="Officer Appointed Date"
                                        value={officerAppointedDate}
                                        showTime={false}
                                        required={true}
                                        initialDate={maxDate}
                                        maxDate={maxDate}
                                        minDate={minCalDate}
                                        normalize={common.dateMasking}
                                        onChange={_func.handleChangeOfficerAppointedDate}
                                        readOnly={false}
                                        disabled={memberCommitteeStatus === 'inactive'}
                                    /> : ''
                                }
                            </Grid.Column>
                        </Grid.Row>
                        {(isShowPreviousOfficer && previousOfficerTitle) && <React.Fragment>
                            <Grid className="previous-officer-titledetail">
                                <Grid.Row columns={2} verticalAlign="middle">
                                    <Grid.Column width={12}>
                                        <strong>Previous Officer Title Details</strong>
                                    </Grid.Column>
                                    <Grid.Column width={4}
                                        className="officer-details__archive-checkbox"
                                    >
                                        <Field name="ArchivePreviousOfficer"
                                            type="checkbox"
                                            component={ReduxCheckboxElement}
                                            label="Archive Record"
                                            onChange={_func.handleOnChangeArchieve}
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row columns={2} verticalAlign="middle">
                                    <Grid.Column width={8}>
                                        <div>
                                            <label className="officer-details__title-label">
                                                Officer Title
                                            </label>
                                            <p>{previousOfficerTitle}</p>
                                        </div>
                                    </Grid.Column>
                                    <Grid.Column width={8}>
                                        <div className='PreviousAppointmentDateContainer'>
                                            <div className='prevOfficerDatebox'>
                                                <Field
                                                    name="PreviousOfficerAppointedDate"
                                                    dataTestId="PreviousOfficerAppointedDate"
                                                    component={DateTimeForm}
                                                    label="Appointed Date"
                                                    value={previousOfficerJoinedDate}
                                                    showTime={false}
                                                    required={true}
                                                    initialDate={maxDate}
                                                    maxDate={maxDate}
                                                    minDate={minCalDate}
                                                    normalize={common.dateMasking}
                                                    onChange={_func.handleChangePreviousOfficerAppointedDate}
                                                    readOnly={false}
                                                    disabled={isArchieveOfficerDetail}
                                                />
                                            </div>
                                            <div className='prevOfficerDatebox'>
                                                <Field
                                                    name="PreviousOfficerEndDate"
                                                    dataTestId="PreviousOfficerEndDate"
                                                    component={DateTimeForm}
                                                    label="End Date"
                                                    value={previousOfficerEndDate}
                                                    showTime={false}
                                                    required={true}
                                                    initialDate={maxDate}
                                                    maxDate={maxDate}
                                                    minDate={minCalDate}
                                                    normalize={common.dateMasking}
                                                    onChange={_func.handleChangePreviousOfficerEndDate}
                                                    readOnly={false}
                                                    disabled={isArchieveOfficerDetail}
                                                />
                                            </div>
                                        </div>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </React.Fragment>
                        }
                        {this.props.MemberTypeId !== MembershipTypes.Student
                            &&
                            <React.Fragment>

                                <Grid.Row>
                                    <Grid.Column>

                                        <Field name="HonoraryStatus" label="Honorary Committee Member"
                                            component={RenderRadioField}
                                            className="mr10"
                                            type="radio"
                                            selectedValue={honoraryStatus}
                                            onChange={(even, value) => _func.handelHonoraryChange(even, value, 'honorary')}
                                            required={true}
                                            options={[{ label: 'Yes', value: 'yes' }, { label: 'No', value: 'no' }]}
                                            isDisabled={!isMemberCommitteeStatusActive}
                                        />
                                    </Grid.Column>
                                    {honoraryStatus === 'yes' && <Grid.Column>
                                        <Field name="CommitteePayStatus" label="Does the committee pay for membership?"
                                            component={RenderRadioField}
                                            className="mr10"
                                            type="radio"
                                            selectedValue={committeePayStatus}
                                            onChange={(even, value) => _func.handelHonoraryChange(even, value, 'committeePay')}
                                            required={true}
                                            options={[{ label: 'Yes', value: 'yes' }, { label: 'No', value: 'no' }]}
                                            isDisabled={!isMemberCommitteeStatusActive}
                                        />
                                    </Grid.Column>}
                                </Grid.Row>
                                {(honoraryStatus === 'yes' && committeePayStatus === 'yes') && <Grid.Row>
                                    <Grid.Column>

                                        <Field name="FeeGroupId"
                                            component={DropdownMultipleSelection} label="Fee Group"
                                            isSearch={true}
                                            isMultiple={false}
                                            isDefaultValue={true}
                                            required={true}
                                            noResultFoundMessage='No results found.'
                                            placeholder="Type to select a fee group"
                                            options={feeGroupList}
                                            disabled={!isMemberCommitteeStatusActive}
                                        />
                                    </Grid.Column>
                                </Grid.Row>}
                            </React.Fragment>
                        }
                    </Grid>

                    <Grid divided='vertically'>
                        <Grid.Row>
                            <Grid.Column>
                                <Field name="ReasonforUpdate"
                                    component={TextArea} required={true} label="Reason for Update"
                                    maxLength="200" placeholder="Please enter the reason for update"
                                />
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>

                    <Confirm className="confirm-box"
                        open={isCommitteeJoinDateGreaterThanClassificationDate || isCommitteeJoinDateGreaterThanVoteDate || isCommitteeJoinDateGreaterThanBothDates}
                        content={common.getMessage(messageCodes, (isCommitteeJoinDateGreaterThanBothDates && '9061.text') || (isCommitteeJoinDateGreaterThanClassificationDate && '9062.text') || (isCommitteeJoinDateGreaterThanVoteDate && '9063.text'))}
                        onCancel={_func.popUpCancel}
                        onConfirm={_func.popUpConfirm}
                        size="tiny"
                        cancelButton="No"
                        confirmButton="Yes"
                    />

                    <Confirm className="confirm-box"
                        data-testid="confirm-box"
                        open={isShowAdministrativeAssistantOrStaffManagerPopup}
                        content={common.getMessage(messageCodes, '9163.text').replace('<Administrative Assistant OR Staff Manager>', officerTitleName).replace('<Main Committee Designation>', committeeName)}
                        onCancel={_func.cancelAdministrativeAssistantOrStaffManagerPopup}
                        onConfirm={_func.confirmAdministrativeAssistantOrStaffManagerPopup}
                        size="tiny"
                        cancelButton="No"
                        confirmButton="Yes"
                    />

                    {isShowAdministrativeAssistantPopup &&
                        <CustomAlertModal content={common.getMessage(messageCodes, '9522.text').replace('@OfficerTitleName', officerTitleName)} handleClick={_func.handleClickOk} />
                    }

                    <CustomConfirmModal className="confirm-box"
                        data-testid="confirm-box"
                        open={isShowArchievePopup}
                        header="Confirmation"
                        closeModal="true"
                        content={(
                            <>
                                <p className="txtCenter">Once archived, the record will no longer appear in the officer history details after saving.</p>
                                <p className="txtCenter">Do you want to archive this record?</p>
                            </>
                        )}
                        onCancel={_func.closeArchievePopup}
                        onConfirm={_func.handleArchieveOfficeChecked}
                        size="tiny"
                        cancelButton="No"
                        confirmButton="Yes"
                    />
                </Form>
            </section>
        )
    }
}
export default reduxForm({
    form: 'MemberCommitteeBasicDetailsEdit',
    validate: _func.validateHandler,
    onSubmit: _func.updateBasicDetails
})(MemberCommitteeBasicDetailsEdit);
